import {useQuery} from "@tanstack/react-query";
import {eventsCalendarGet} from "../api/events/eventsCalendarGet.ts";

export const useEventCalendar = () => useQuery({
    queryKey: ['eventCalendar'],
    queryFn: () => eventsCalendarGet().then(r => r.payload)
})